import { render, staticRenderFns } from "./component.vue?vue&type=template&id=c9b9604a&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=c9b9604a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b9604a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9b9604a')) {
      api.createRecord('c9b9604a', component.options)
    } else {
      api.reload('c9b9604a', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=c9b9604a&scoped=true&", function () {
      api.rerender('c9b9604a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/nftCollection/component.vue"
export default component.exports